<app-header-component
  [headerData]="currentHeaderData"
  (closeModal)="closeModal()"
></app-header-component>
<ion-content class="ion-padding-vertical">
  <div
    class="form ion-padding-horizontal"
    *ngIf="formQuestionData; else noQuestions"
  >
    <div>
      <ion-button
        expand="block"
      class="ion-margin-bottom outline-btn"
      [disabled]="isGuestListModalOpen"
        (click)="selectfromGuestList()"
      >
        <ion-icon name="people-outline" slot="start"></ion-icon>
        <span class="fs-3 font500" slot="start">
          {{ "hotel.booking_review.select_guest" | translate }}
        </span>
      </ion-button>
    </div>
    <form [formGroup]="form">
      <div *ngFor="let item of formFields" class="”form-group”">
        <div
          class="ion-margin-bottom"
          *ngIf="item.field_type === 'string' && item.name !== 'calling_code'"
        >
          <ion-input
            required
            autocomplete="off"
            [label]="item.question"
            labelPlacement="floating"
            name="item['name']"
            class="”form-control” primary-input"
            [formControlName]="item.name"
            aria-label="text"
          ></ion-input>
        </div>
        <div class="ion-margin-bottom" *ngIf="item.field_type === 'email'">
          <ion-input
            required
            autocomplete="off"
            [label]="item.question"
            labelPlacement="floating"
            name="item['name']"
            type="email"
            class="”form-control” primary-input"
            [formControlName]="item.name"
            aria-label="text"
          ></ion-input>
        </div>
        <div
          *ngIf="item.field_type === 'int' && item.name === 'phone_number'"
          class="ion-margin-bottom input-border"
        >
          <div class="d-flex ion-align-items-center">
            <ion-button
              (click)="selectCountryCode()"
              class="fs-3 ion-no-margin ion-no-padding padl10 clear-btn d-flex calling-code-btn"
              *ngIf="isCallingCode()"
            >
              <span>{{ selectedCountryCode.flag }}</span>
              <span> {{ selectedCountryCode.dialCode }}</span>
              <ion-icon
                class="fs-4 primary-icon-color padr5"
                slot="end"
                name="chevron-down-outline"
              ></ion-icon>
            </ion-button>
            <ion-input
              required
              autocomplete="off"
              [label]="item.question"
              labelPlacement="floating"
              [name]="item['name']"
              [type]="item['type']"
              [placeholder]="item.placeholder"
              [required]="item?.rules?.required"
              [formControlName]="item.name"
              class="primary-input mobile-input"
            >
            </ion-input>
          </div>
        </div>
        <div
          class="ion-margin-bottom"
          *ngIf="item.field_type === 'int' && item.name !== 'phone_number'"
        >
          <ion-input
            required
            autocomplete="off"
            [label]="item.question"
            labelPlacement="floating"
            name="item['name']"
            type="number"
            class="”form-control” primary-btn"
            [formControlName]="item.name"
            aria-label="text"
          ></ion-input>
        </div>
        <div
          class="ion-margin-top ion-margin-bottom"
          *ngIf="item.field_type === 'date'"
        >
          <ion-input
            type="date"
            [min]="item.name === 'pickup_date' ? minPickupDate : ''"
            [max]="item.name === 'date_of_birth' ? validBdate : ''"
            [name]="item.name"
            required
            [label]="item.question"
            labelPlacement="floating"
            [formControlName]="item.name"
            aria-label="text"
            class="primary-input"
          >
            <div slot="label" class="date-label">{{ item.question }}</div>
          </ion-input>
        </div>
        <div
          class="ion-margin-top ion-margin-bottom"
          *ngIf="item.field_type === 'time'"
        >
          <ion-input
            type="time"
            name="pickup_time"
            required
            [label]="item.question"
            labelPlacement="floating"
            [formControlName]="item.name"
            aria-label="text"
            class="primary-input"
          >
            <div slot="label" class="time-label">{{ item.question }}</div>
          </ion-input>
          <div
            *ngIf="form.get('pickup_time').errors?.lessThanBaseTime"
            class="validation-error"
          >
            {{ form.get("pickup_time").errors?.lessThanBaseTime?.message }}
          </div>
        </div>
        <div
          class="ion-margin-bottom"
          *ngIf="
            item.field_type === 'options' &&
            (item.name === 'travel_doc_country' || (item.name && item.name.includes('destination'))) &&
            item.optionList && item.optionList.length > 5
          "
        >
          <ion-item lines="none" class="option-select-border" (click)="openOptionListModal(item)"> 
            <ion-label [class.item-label]="!form.get(item.name)?.value">
              {{ form.get(item.name)?.value || item.question }}
            </ion-label>
            <!-- <ion-icon name="chevron-down-outline" slot="end"></ion-icon> -->
          </ion-item>
        </div>
        <div class="ion-margin-bottom" *ngIf="item.field_type === 'options' && !((item.name === 'travel_doc_country' || (item.name && item.name.includes('destination'))) && item.optionList && item.optionList.length > 5)">
          <ion-select
            class="ion-no-padding"
            required
            [label]="item.question"
            labelPlacement="floating"
            [formControlName]="item.name"
            interface="popover"
            class="primary-select"
          >
            <ion-select-option
              *ngFor="let element of item.optionList"
              value="{{ element }}"
              >{{ element }}</ion-select-option
            >
          </ion-select>
        </div>
      </div>

      <div
      class="checkbox-container ion-bg-white d-flex ion-align-items-start ion-margin-top"
      lines="none"
    >
      <ion-checkbox
        slot="start"
        class="ion-no-margin marr10 white-border-checkbox"
        [checked]="saveGuest"
        (ionChange)="saveGuest = $event.detail.checked" aria-label="agree"
        (click)="guestSaveCheckboxClick()"
      ></ion-checkbox>
      <ion-label
        class="fs-2 font500 ion-no-padding ion-no-margin l-height19 card-primary-text-color"
      >
        {{"hotel.booking_review.save_guest" | translate}}
      </ion-label>
    </div>

      <ion-button
        type="submit"
        expand="block"
        class="place_order fs-3 font600 primary-btn"
        (click)="submitRequest()"
        [disabled]="!isFormReady || isSubmitting || !formFields?.length"
      >
        {{ "autocheckout_form.place_order" | translate }}
      </ion-button>
    </form>
  </div>

  <ng-template #noQuestions>
    <no-data [message]="'error.something_wrong' | translate"></no-data>
  </ng-template>
</ion-content>
